<!-- 案由详情页 -->
<template>
    <div class="v-qzdetails">
        <c-header></c-header>
        <div class="content">
            <Breadcrumb separator=">" class="crumb-title">
                <BreadcrumbItem to="/home">首页</BreadcrumbItem>
                <BreadcrumbItem to="/causelist">事由列表</BreadcrumbItem>
                <BreadcrumbItem :title="DetailsData.title">{{ DetailsData.title }}</BreadcrumbItem>
            </Breadcrumb>

            <div class="details">
                <div class="details-title" :title="DetailsData.title">
                    {{ DetailsData.title }}
                </div>
                <div class="details-info" v-if="Object.keys(DetailsData).length != 0">
                    <div class="details-panel-title">
                        <h3>基本信息</h3>
                    </div>
                    <div class="details-table-basic">
                        <table class="basicinfo-table">
                            <tr class="table-border-tr">
                                <td class="table-subtitle">事项编码</td>
                                <td class="table-content">{{ DetailsData.sxbm }}</td>
                                <td class="table-subtitle">行使层级</td>
                                <td class="table-content">{{ DetailsData.xscj }}</td>
                                <td class="table-subtitle">所属领域</td>
                                <td class="table-content">{{ DetailsData.zqly }}</td>
                            </tr>
                            <tr>
                                <td class="table-subtitle">事项类型</td>
                                <td class="table-content">{{ DetailsData.zqlx }}</td>
                                <td class="table-subtitle">行使主体</td>
                                <td class="table-content">{{ DetailsData.xszt }}</td>
                                <td class="table-subtitle">行使主体性质</td>
                                <td class="table-content">{{ DetailsData.xsztxz }}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="details-panel-item panel-item-country" ref="panel-item-country"
                        v-if="DetailsData.countryLawList && DetailsData.countryLawList.length">
                        <div class="details-panel-title">
                            <h3>国家级设定依据</h3>
                        </div>
                        <div class="table-panel" v-for="item in DetailsData.countryLawList">
                            <table class="details-table">
                                <tr>
                                    <td class="table-title" rowspan="3">设立依据</td>
                                    <td class="table-subtitle">法律法规名称</td>
                                    <td class="table-content">{{ item.lawTitle }}</td>
                                    <td class="table-subtitle">颁布机关</td>
                                    <td class="table-content">{{ item.bbjg }}</td>
                                </tr>
                                <tr class="table-border-tr">
                                    <td class="table-subtitle">依据文号</td>
                                    <td class="table-content">{{ item.yjwh }}</td>
                                    <td class="table-subtitle">实施日期</td>
                                    <td class="table-content">{{ item.ssTime }}</td>
                                </tr>
                                <tr>
                                    <td class="table-subtitle">条款号</td>
                                    <td class="table-content" v-html="renderContent(item.tkNum)"></td>
                                    <td class="table-subtitle">条款内容</td>
                                    <td class="table-content" v-html="renderContent(item.content)"></td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="details-panel-item panel-item-place" ref="panel-item-place"
                        :class="DetailsData.localLawList.length > 3 ? 'default-panel-max' : 'default-panel-height'"
                        v-if="DetailsData.localLawList && DetailsData.localLawList.length">
                        <div class="details-panel-title">
                            <i class="panel-title-icon icon-place-info"></i>
                            <h3>省级设定依据</h3>
                        </div>
                        <div class="table-panel" v-for="item in DetailsData.localLawList">
                            <table class="details-table">
                                <tr>
                                    <td class="table-title" rowspan="3">设立依据</td>
                                    <td class="table-subtitle">法律法规名称</td>
                                    <td class="table-content">{{ item.lawTitle }}</td>
                                    <td class="table-subtitle">颁布机关</td>
                                    <td class="table-content">{{ item.bbjg }}</td>
                                </tr>
                                <tr class="table-border-tr">
                                    <td class="table-subtitle">依据文号</td>
                                    <td class="table-content">{{ item.yjwh }}</td>
                                    <td class="table-subtitle">实施日期</td>
                                    <td class="table-content">{{ item.ssTime }}</td>
                                </tr>
                                <tr>
                                    <td class="table-subtitle">条款号</td>
                                    <td class="table-content" v-html="renderContent(item.tkNum)"></td>
                                    <td class="table-subtitle">条款内容</td>
                                    <td class="table-content" v-html="renderContent(item.content)"></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <c-footer></c-footer>
    </div>
</template>

<script>
    import CHeader from '@/components/CHeader'
    import CFooter from '@/components/CFooter'
    import { reqQuanzeDetails } from "@/api/index";
    export default {
        name: 'VDetails',
        components: {
            CHeader,
            CFooter
        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'details-demo'
                }
            }
        },
        data() {
            return {
                DetailsData: {}
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
            this.getQuanzeDetailsData();
        },
        destroyed() {

        },
        methods: {
            // 请求 活回去权责清单列表
            getQuanzeDetailsData() {
                reqQuanzeDetails({ id: this.$route.query.id }).then(res => {
                    this.DetailsData = res.data;
                })
            },

            renderContent(str) {
                let result = '';
                result = str.replace(/\n/g, "<br>");
                return result;
            }
        }
    }
</script>

<style scoped>
    .v-qzdetails {
        height: 100%;
        background-color: #f7f8f8;
    }

    .content {
        margin: 0 auto;
        width: 1200px;
        height: calc(100% - 50px - 112px);
        min-height: calc(100% - 50px - 112px);
        background-color: #f7f8f8;
    }

    .details-panel {
        margin-bottom: 20px;
    }

    .details {
        height: calc(100% - 61px - 20px);
        background-color: #fff;
    }

    .details-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 16px;
        border-bottom: 3px solid #cecfd3;
        font-size: 18px;
        font-weight: bold;
        color: #404e65;
    }

    .crumb-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .details-info {
        overflow: auto;
        height: calc(100% - 65px);
        padding: 16px;
    }

    .details-panel-title {
        margin: 10px 4px;
    }

    .basicinfo-table {
        width: 100%;
    }

    .basicinfo-table td {
        padding: 16px;
        font-size: 16px;
    }

    .basicinfo-table .table-subtitle {
        font-weight: bold;
        color: #2d4060;
        background-color: #d8e5fa;
    }

    .basicinfo-table .table-content {
        color: #515a6e;
        background-color: #F7F8FB;
    }

    .details-table td {
        padding: 16px;
        font-size: 16px;
    }

    .details-table .table-title {
        width: 11%;
        font-weight: bold;
        color: #2d4060;
        background-color: #65a5c4;
    }

    .details-table .table-subtitle {
        width: 13%;
        color: #2d4060;
        background-color: #d8e5fa;
    }

    .details-table .table-content {
        width: 31%;
        color: #515a6e;
        background-color: #F7F8FB;
    }
</style>